import ApiService from '@/services/api'

// Recupera token do localStorage na inicialização
const token = localStorage.getItem('_token')
if (token && token.startsWith('Bearer ')) {
  const bearerToken = token.replace('Bearer ', '')
  ApiService.setAuthToken(bearerToken)
}

// Recupera apenas o ID do localStorage
const userStorage = localStorage.getItem('user-nexa')
let initialUser = null
if (userStorage) {
  try {
    const parsed = JSON.parse(userStorage)
    // Se tiver apenas ID, mantém assim. Se tiver dados completos, mantém também
    initialUser = parsed
  } catch (e) {
    initialUser = null
  }
}

const state = {
  user: initialUser,
  loading: false,
  error: null
}

const getters = {
  isAuthenticated: state => {
    // Está autenticado se tiver user OU se tiver token e ID no localStorage
    if (state.user && state.user.id) return true
    const token = localStorage.getItem('_token')
    const userStorage = localStorage.getItem('user-nexa')
    return !!(token && userStorage)
  },
  getUser: state => state.user,
  isLoading: state => state.loading,
  getError: state => state.error
}

const mutations = {
  SET_USER(state, user) {
    state.user = user
    // Salva apenas o ID no localStorage
    if (user && user.id) {
      localStorage.setItem('user-nexa', JSON.stringify({ id: user.id }))
    }
  },
  UPDATE_USER_DATA(state, user) {
    // Atualiza apenas o state do Vuex, sem tocar no localStorage
    state.user = user
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  CLEAR_ERROR(state) {
    state.error = null
  },
  LOGOUT(state) {
    state.user = null
    state.error = null
    localStorage.removeItem('user-nexa')
    localStorage.removeItem('_token')
    ApiService.clearAuth()
  }
};

const actions = {
  /**
   * Registrar novo usuário
   * @param {object} userData - Dados do usuário
   */
  async register({ commit }, userData) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      const data = {
        usuario: userData.usuario,
        nome: userData.nome,
        email: userData.email,
        senha: userData.senha,
        confirmacao_senha: userData.confirmacao_senha
      }
      
      const response = await ApiService.post('/Usuarios/register', data)
      
      commit('SET_LOADING', false)
      return { success: true, data: response }
      
    } catch (error) {
      commit('SET_LOADING', false)
      commit('SET_ERROR', error.message || 'Erro ao registrar usuário')
      return { success: false, error: error.message || 'Erro ao registrar usuário' }
    }
  },

  /**
   * Login do usuário
   * @param {object} credentials - Credenciais de login
   */
  async login({ commit }, credentials) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      const data = {
        username: credentials.username,
        password: credentials.password
      }
      
      const response = await ApiService.post('/Usuarios/login', data)
      
      // Se a API retornar um token, configura a autenticação
      if (response.token) {
        // Salva o token no formato Bearer no localStorage
        localStorage.setItem('_token', `Bearer ${response.token}`)
        ApiService.setAuthToken(response.token)
      }
      
      // Salva APENAS o ID no localStorage
      const userId = response.usuario?.id
      if (userId) {
        localStorage.setItem('user-nexa', JSON.stringify({ id: userId }))
      }
      
      commit('SET_LOADING', false)
      
      // Busca dados completos do usuário que irá popular o Vuex
      if (userId) {
        await this.dispatch('usuario/fetchUsuarioById', userId)
      }
      
      return { success: true, data: response }
      
    } catch (error) {
      commit('SET_LOADING', false)
      
      // Extrai mensagem específica do erro
      let errorMessage = 'Erro ao fazer login'
      
      // O ApiService já trata e estrutura o erro, então acessamos diretamente
      if (error.message) {
        errorMessage = error.message
      } else if (error.response?.data?.message) {
        // Fallback para erro bruto do axios se não passou pelo handleError
        errorMessage = error.response.data.message
      } else if (typeof error === 'string') {
        errorMessage = error
      }
      
      commit('SET_ERROR', errorMessage)
      return { success: false, error: errorMessage }
    }
  },

  /**
   * Logout do usuário
   */
  logout({ commit }) {
    commit('LOGOUT')
  },

  /**
   * Limpar erro
   */
  clearError({ commit }) {
    commit('CLEAR_ERROR')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
